import { notification } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PermissionAccess from "../utils/permission";
import { NO_PERMISSION_MESSAGE } from "../utils/utils";
import { GetLoggedInUser } from "../utils/utils";
import { isSuperAdmin } from "../utils/utils";

// export const usePermission = (module, type) => {

//     const [permission, setPermission] = useState(false);
//     const navigate = useNavigate();
//     let Permission = PermissionAccess(module)

//     useEffect(() => {
//         if (Permission && Permission[type]) {
//             setPermission(true);
//         } else {
//             setPermission(false);
//             navigate("/dashboard", { replace: true });
//             notification.destroy()
//             notification["error"]({
//                 message: NO_PERMISSION_MESSAGE
//             })
//         }
//     }, [Permission])
//     return permission
// };

// usePermission.js
// export const usePermission = (module, type) => {
//     const [permission, setPermission] = useState(false);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const checkPermission = () => {
//             const user = GetLoggedInUser();

//             // Super admin has all permissions
//             if (isSuperAdmin()) {
//                 setPermission(true);
//                 return;
//             }

//             // Check if module exists in permissions
//             if (!user?.permissions || !user.permissions[module]) {
//                 setPermission(false);
//                 navigate("/dashboard", { replace: true });
//                 notification.destroy()
//                 notification["error"]({
//                     message: NO_PERMISSION_MESSAGE
//                 });
//                 return;
//             }

//             // Check specific permission type
//             const modulePermission = user.permissions[module];
//             let hasPermission = false;

//             switch(type) {
//                 case "List":
//                     hasPermission = modulePermission == 1;
//                     break;
//                 case "Add":
//                     hasPermission = modulePermission == 2 || modulePermission == 4 || modulePermission === 5;
//                     break;
//                 case "Edit":
//                     hasPermission = modulePermission == 3  || modulePermission == 4 || modulePermission === 5;
//                     break;
//                 case "Delete":
//                     hasPermission = modulePermission === 5;
//                     break;
//                 default:
//                     hasPermission = false;
//             }

//             if (!hasPermission) {
//                 navigate("/dashboard", { replace: true });
//                 notification.destroy()
//                 notification["error"]({
//                     message: NO_PERMISSION_MESSAGE
//                 });
//             }

//             setPermission(hasPermission);
//         };

//         checkPermission();
//     }, [module, type, navigate]);

//     return permission;
// };

// usePermission.js
export const usePermission = (module, type) => {
  console.log(module, type);

  const [permission, setPermission] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkPermission = () => {
      const user = GetLoggedInUser();

      // Super admin has all permissions
      if (isSuperAdmin()) {
        setPermission(true);
        return;
      }

      // Check if module exists in permissions
      if (!user?.permissions || user.permissions[module] === undefined) {
        setPermission(false);
        navigate("/dashboard", { replace: true });
        notification.destroy();
        notification["error"]({
          message: NO_PERMISSION_MESSAGE,
        });
        return;
      }

      // Check specific permission type
      const modulePermission = user.permissions;

      let hasPermission = false;
      switch (type) {
        case "List":
          hasPermission = modulePermission[module] >= 1;
          break;
        case "Add":
          hasPermission =
            modulePermission[module] == 2 ||
            modulePermission[module] == 4 ||
            modulePermission[module] == 5;
          break;
        case "Edit":
          hasPermission =
            modulePermission[module] == 3 ||
            modulePermission[module] == 4 ||
            modulePermission[module] == 5;
          break;
        case "Delete":
          hasPermission = modulePermission[module] == 5;
          break;
        default:
          hasPermission = false;
      }
      if (!hasPermission && module == "List") {
        navigate("/dashboard", { replace: true });
        notification.destroy();
        notification["error"]({
          message: NO_PERMISSION_MESSAGE,
        });
      }

      setPermission(hasPermission);
    };

    checkPermission();
  }, [module, type, navigate]);

  return permission;
};
